import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useState, useRef, useMemo } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcode, faCoins, faReceipt, faUser, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, changeUnits, formatUTCDateTime } from '../common/function';
import { changeAlramModal, changeShoppingFlag, changeShoppingFriend, changeShoppingTab, checkDuplicateLogins } from '../../store';
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft, Trash2, X, Plus, ReceiptText, Check, RefreshCw } from 'lucide-react';
import { SyncLoader } from "react-spinners";
import Coupons_Header_Soda from './common/coupons_header_soda';
import FallbackImage from '../common/FallbackImage';
import Coupons_Footer from '../common/coupons_footer';

import { FreeMode, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function Shopping_Soda() {
    const { t } = useTranslation();

    const mySkin = useSelector((state) => state.mySkin);
    const JWT = useSelector((state) => state.JWT.value);
    const shoppingTab = useSelector((state) => state.shoppingTab.value);
    const gold = useSelector((state) => { return state.gold.value })
    const mobileType = useSelector((state) => { return state.mobileType.value })
    const banner = useSelector((state) => { return state.banner })
    const Languages = useSelector((state) => { return state.Languages.value })

    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [totalList, setTotalList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalData, setTotalData] = useState(0)
    const [maxFirstCnt, setMaxFirstCnt] = useState(48)
    const [listSpinner, setListSpinner] = useState(true)

    const [isDataLoading, setIsDataLoading] = useState(true);

    const tabs = ['0', '1'];

    const dispatch = useDispatch();
    const navigate = useNavigate(); // 라우터 이동을 위해 사용
    const location = useLocation();

    useEffect(() => {
        CategoryData();
    }, []);

    useEffect(() => {
        if (page === 1) setListSpinner(true)
        ListData()
    }, [page]);

    const CategoryData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + '/api/sodagift/coupon/user/coupon-categories',
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data?.data ?? [];
            setCategories(tmp?.types ?? [])
            setBrands(tmp?.brands ?? [])
            setIsDataLoading(false)
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const ListData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("page", page.toString());
            params.append("take", maxFirstCnt);
            params.append("coupon_type", "");
            params.append("brand", "");

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/sodagift/coupon/user/latest-exchanged-products',
                params,
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data ?? [];
            setTotalList((prev) => [...prev, ...tmp?.data ?? []]);
            setTotalData(tmp?.total ?? 0)
            setListSpinner(false)

        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const handleSelectCoupon = (coupon) => {
        navigate(`/shoppingDetail/${coupon.ci_goods_no}`, {
            state: { item: coupon },
        });
    };

    const observerRef = useRef(null);
    useEffect(() => {
        if (totalList.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalData > page * maxFirstCnt) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [totalList]);

    const SkeletonItems = ({ countPerSlide, slideClass, itemClass }) => (
        <>
            <div className={`${slideClass}-wrapper`}>
                {Array.from({ length: Math.ceil(countPerSlide / countPerSlide) }).map((_, i) => {
                    const padded = Array(countPerSlide).fill(null);
                    return (
                        <div key={i} className={slideClass}>
                            {padded.map((_, idx) => (
                                <div key={idx} className={`${itemClass} skeleton`} />
                            ))}
                        </div>
                    );
                })}
            </div>
            <div className="slide-indicator">
                {Array.from({ length: Math.ceil(countPerSlide / countPerSlide) }).map((_, i) => (
                    <div key={i} className="slide-dot active" />
                ))}
            </div>
        </>
    );

    const swiperBrandRef = useRef(null);

    // 8개씩 청킹 + 마지막 슬라이드 패딩(null 채우기)
    const chunkedBrand = useMemo(() => {
        const size = 8;
        const chunks = [];
        for (let i = 0; i < brands.length; i += size) {
            const group = brands.slice(i, i + size);
            if (group.length < size) {
                chunks.push([...group, ...Array(size - group.length).fill(null)]);
            } else {
                chunks.push(group);
            }
        }
        // brands가 비어있을 때도 최소 1슬라이드 유지하고 싶으면 아래 주석 해제
        // if (chunks.length === 0) chunks.push(Array(8).fill(null));
        return chunks;
    }, [brands]);

    const swiperCategoryRef = useRef(null);

    // 15개(5x3)로 청킹 + 마지막 슬라이드 패딩(null)
    const chunkedCategory = useMemo(() => {
        const size = 15;
        const chunks = [];
        for (let i = 0; i < categories.length; i += size) {
            const group = categories.slice(i, i + size);
            chunks.push(group.length < size ? [...group, ...Array(size - group.length).fill(null)] : group);
        }
        // categories가 비어도 pagination 안 보이게 하려면 빈 배열 유지
        return chunks;
    }, [categories]);

    return (
        <div
            className="friend"
            style={{
                background: "#f5f5f5",
                padding: "0px",
                position: "relative",
                color: "#000"
            }}
        >
            <div style={{ padding: '0px', paddingBottom: '60px', fontFamily: 'sans-serif' }}>
                <Coupons_Header_Soda pageName={t('shopping_0')} text={"shopping_4"} />

                <div className="gift-scroll-container">
                    <div style={{ padding: "12px 15px", background: "#fbec4e", display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "14px", color: "#000", borderRadius: "10px" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <FontAwesomeIcon icon={faCoins} style={{ paddingRight: "3px", color: "#414141" }} />{t('shopping_5')}
                        </div>
                        <div style={{ fontWeight: "bold" }}>{changeNum(gold)}p</div>
                    </div>
                </div>
                <div style={{ width: "100%", background: "#fff", padding: "15px" }}>
                    <div className="tab-container">
                        {tabs.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-button ${shoppingTab === tab ? 'active' : ''}`}
                                onClick={() => dispatch(changeShoppingTab(tab))}
                            >
                                {tab === "0" ? t('shopping_1') : t('shopping_2')}
                            </button>
                        ))}
                    </div>
                    <div style={{ height: "260px" }}>
                        {
                            shoppingTab == '0' ? (
                                isDataLoading
                                    ?
                                    <SkeletonItems countPerSlide={15} slideClass="category-slide" itemClass="category-item" />
                                    :
                                    <Swiper
                                        ref={swiperCategoryRef}
                                        slidesPerView={1}
                                        spaceBetween={20}
                                        pagination={{
                                            clickable: true,
                                            bulletClass: "my-bullet",
                                            bulletActiveClass: "my-bullet-active"
                                        }}
                                        modules={[Pagination]}
                                        speed={600}
                                        watchOverflow={false}
                                        loop={false}
                                        className="category-swiper style_dot2"
                                        style={{ margin: 0, height: "270px" }}
                                    >
                                        {chunkedCategory.map((group, i) => (
                                            <SwiperSlide key={i}>
                                                <div className="category-grid">
                                                    {group.map((cat, idx) => (
                                                        <div
                                                            key={idx}
                                                            className={`category-item ${cat ? "" : "placeholder"}`}
                                                            onClick={() => cat && navigate("/categoriesList", { state: { brands: "", types: cat } })}
                                                            role={cat ? "button" : "presentation"}
                                                            style={{ height: "70px" }}
                                                        >
                                                            {cat ? (
                                                                <>
                                                                    <img
                                                                        loading="lazy"
                                                                        alt={cat.pc_category_name_display ?? "카테고리"}
                                                                        src={cat?.pc_category_img ?? "/newImg/preparing.png"}
                                                                    />
                                                                    <div className="category-name table-overflow-1line">
                                                                        {cat.pc_category_name_display}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="category-empty" />
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                            ) : (
                                isDataLoading
                                    ?
                                    <SkeletonItems countPerSlide={8} slideClass="brand-slide" itemClass="brand-card" />
                                    :
                                    <Swiper
                                        ref={swiperBrandRef}
                                        slidesPerView={1}
                                        spaceBetween={20}
                                        pagination={{
                                            clickable: true,
                                            bulletClass: "my-bullet",
                                            bulletActiveClass: "my-bullet-active"
                                        }}
                                        modules={[Pagination]}
                                        speed={600}
                                        watchOverflow={false}
                                        className="brand-swiper style_dot2"
                                        style={{ margin: "0", height: "270px" }}
                                    >
                                        {chunkedBrand.map((group, i) => (
                                            <SwiperSlide key={i}>
                                                <div className="brand-grid">
                                                    {group.map((brand, idx) => (
                                                        <div
                                                            key={idx}
                                                            className={`brand-card ${brand ? "" : "placeholder"}`}
                                                            onClick={() =>
                                                                brand &&
                                                                navigate("/brandsList", { state: { brands: brand, types: "" } })
                                                            }
                                                            role={brand ? "button" : "presentation"}
                                                            style={{ height: "54px" }}
                                                        >
                                                            {brand ? (
                                                                <>
                                                                    <img
                                                                        loading="lazy"
                                                                        alt={brand.pc_category_name}
                                                                        src={
                                                                            brand?.pc_category_custom_img
                                                                                ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${brand?.pc_category_custom_img}`
                                                                                : brand?.pc_category_img ?? "/newImg/preparing.png"
                                                                        }
                                                                    />
                                                                    <div className="brand-texts" style={{ width: 100 }}>
                                                                        <div className="brand-label table-overflow-1line">
                                                                            {brand.pc_category_name}
                                                                        </div>
                                                                        <div className="brand-desc table-overflow-1line">
                                                                            #{brand.pc_associated_category_names}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                // 자리만 차지 (UI 흔들림 방지)
                                                                <div className="brand-empty" />
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                            )
                        }
                    </div>
                    <img
                        src="/newImg/banner_shopping_ph.png"
                        style={{ width: "100%", borderRadius: "10px", margin: "25px 0", cursor: "pointer" }}
                        onClick={() => window.open(
                            mobileType == 0
                                ? "https://play.google.com/store/apps/details?id=com.feelspic.securet&hl=ko&pli=1"
                                : "https://apps.apple.com/kr/app/securet-for-communication-%EC%8B%9C%ED%81%90%EB%A6%BF/id6451279827")}
                    />
                    <div style={{ background: '#fff' }}>
                        <div style={{ fontSize: "20px", fontWeight: "bold", textAlign: "left", marginBottom: "2px" }}>{t('shopping_6')}</div>
                        <div style={{ fontSize: "12px", fontWeight: "500", textAlign: "left", marginBottom: "10px", color: "gray" }}>{t('shopping_7')}</div>
                        <div style={{ fontSize: "12px", fontWeight: "500", color: "gray", marginBottom: "10px" }}>
                            {
                                totalList?.length > 0 && (
                                    <div style={{ width: "150px", padding: "6px", border: "1px solid #e1e1e1", borderRadius: "20px", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}
                                    // onClick={() => { setPage(1); ListData() }}
                                    >
                                        {
                                            Languages == "ko-KR"
                                                ?
                                                `${formatUTCDateTime(totalList[0]?.latest_exchange_time)?.slice(0, -3)} 기준`
                                                :
                                                `As of ${formatUTCDateTime(totalList[0]?.latest_exchange_time)?.slice(0, -3)}`
                                        }
                                    </div>
                                )
                            }
                        </div>
                        {
                            listSpinner
                                ?
                                <div style={{ marginTop: "100px" }}>
                                    <SyncLoader
                                        color="#ffbb3f"
                                        size={10}
                                        cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                                        speedMultiplier={1}
                                    />
                                </div>
                                :
                                totalList?.length > 0
                                    ?
                                    <>
                                        <div
                                            style={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(3, 1fr)',
                                                gap: '7px'
                                            }}
                                        >
                                            {totalList.map((item, idx) => (
                                                <div key={idx}
                                                    style={{
                                                        overflow: 'hidden',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => handleSelectCoupon(item)}
                                                >
                                                    <FallbackImage
                                                        src={item?.ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${item.ci_custom_image_filename}` : item.ci_goods_img_big}
                                                        alt={`img_${item.id}`}
                                                        style={{ width: '100%', aspectRatio: "1/1", objectFit: 'cover', borderRadius: "5px", border: "1px solid #f9f9f9" }}
                                                    />
                                                    <div
                                                        style={{
                                                            padding: '0px 0 10px',
                                                            textAlign: "left",
                                                            fontSize: "14px",
                                                            background: "#fff",
                                                            marginTop: "3px"
                                                        }}
                                                    >
                                                        <div
                                                            className="table-overflow-1line"
                                                            style={{ color: "gray", fontWeight: "500", fontSize: "13px" }}
                                                        >
                                                            {item.ci_brand_name}
                                                        </div>
                                                        <div
                                                            className="table-overflow-2lines"
                                                            style={{ color: '#000', marginBottom: "4px" }}
                                                        >
                                                            {item.ci_goods_name}
                                                        </div>
                                                        <div style={{ color: '#000', fontWeight: "bold" }}>
                                                            {changeNum(item.ci_point_price)}p
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div ref={observerRef} style={{ height: '1px' }}></div>
                                    </>
                                    :
                                    <div style={{ width: "100%", margin: "30px 0" }}>
                                        <img src={`${process.env.REACT_APP_API}${mySkin.skin_img}`} style={{ width: "150px", marginBottom: "10px" }} />
                                        <div style={{ width: "100%", textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#000" }}>{t('shopping_9')}</div>
                                    </div>
                        }
                    </div>
                </div>
                <Coupons_Footer />
            </div>
        </div>
    );
}

export default Shopping_Soda;